import React from "react";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import IconButton from "@material-ui/core/IconButton";
import styles from "./UserInput.module.scss";

function UserInput({ className = styles.UserInput, ...props }) {
  const [visibility, setVisibility] = React.useState(props.type ? false : true);
  return (
    <div className={`${styles.UserInputContainer} MarginHorizontal`}>
      {props.type === "password" ? (
        visibility ? (
          <IconButton
            onClick={() => setVisibility(false)}
            className={styles.IconButtonStyle}
          >
            <Visibility />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => setVisibility(true)}
            className={styles.IconButtonStyle}
          >
            <VisibilityOff />
          </IconButton>
        )
      ) : null}
      <input
        key={props.key}
        className={className}
        type={visibility ? "text" : "password"}
        id={props.id}
        placeholder="Type..."
        onChange={props.onChange}
        value={props.value}
        disabled={props.disabled}
        error={props.error}
        style={props.inputStyle}
      />
      <label style={props.labelStyle} htmlFor={props.id}>
        {props.name}
      </label>
    </div>
  );
}

export default UserInput;
